var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBaloonAlt3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1127 13.897C15.8948 13.3753 18 10.9335 18 8C18 4.68629 15.3137 2 12 2C8.68629 2 6 4.68629 6 8C6 10.9335 8.10524 13.3753 10.8873 13.897L9.55 14.9C9.21863 15.1485 9.15147 15.6186 9.4 15.95C9.64853 16.2814 10.1186 16.3485 10.45 16.1L11.25 15.5V17.3333C11.25 18.668 12.332 19.75 13.6667 19.75H15.5C15.9142 19.75 16.25 20.0858 16.25 20.5C16.25 20.9142 15.9142 21.25 15.5 21.25H8C7.58579 21.25 7.25 21.5858 7.25 22C7.25 22.4142 7.58579 22.75 8 22.75H15.5C16.7426 22.75 17.75 21.7426 17.75 20.5C17.75 19.2574 16.7426 18.25 15.5 18.25H13.6667C13.1604 18.25 12.75 17.8396 12.75 17.3333V15.5L13.55 16.1C13.8814 16.3485 14.3515 16.2814 14.6 15.95C14.8485 15.6186 14.7814 15.1485 14.45 14.9L13.1127 13.897ZM11.25 5C11.25 4.58579 11.5858 4.25 12 4.25C14.0711 4.25 15.75 5.92893 15.75 8C15.75 8.41421 15.4142 8.75 15 8.75C14.5858 8.75 14.25 8.41421 14.25 8C14.25 6.75736 13.2426 5.75 12 5.75C11.5858 5.75 11.25 5.41421 11.25 5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaloonAlt3);
export default __webpack_public_path__ + "static/media/baloon-alt-3.a95ac2a95b9f5350464c81598fcda1cb.svg";
export { ForwardRef as ReactComponent };